export const AUTH_TOKENS_DATE_FORMAT = 'MMM DD, YYYY';
